import { language } from "language/default";
export var ViolationType;
(function (ViolationType) {
    ViolationType[ViolationType["NoViolation"] = 0] = "NoViolation";
    ViolationType[ViolationType["Potential"] = 1] = "Potential";
    ViolationType[ViolationType["Violation"] = 2] = "Violation";
})(ViolationType || (ViolationType = {}));
const isSupplyChain = (value) => value?.toLowerCase()?.endsWith("supplychain");
const isViolator = (value) => value?.toLowerCase()?.startsWith("violator");
const { principlesTable } = language.en.widgets;
export const getPrincipleCodeDescription = (value) => {
    if (!value) {
        return value;
    }
    const stringValue = value.toString();
    const isViolatorValue = isViolator(stringValue) ? "" : `${principlesTable.potential} `;
    const isSupplyChainValue = isSupplyChain(stringValue) ? principlesTable.supplyChain : principlesTable.operations;
    return `${isViolatorValue}${principlesTable.violator} ${isSupplyChainValue}`;
};
export const getPrincipleSource = (value) => {
    if (value) {
        return isSupplyChain(value) ? principlesTable.supplyChain : principlesTable.operations;
    }
    return value;
};
export const getPrincipleStatus = (value) => {
    if (value) {
        return isViolator(value) ? ViolationType.Violation : ViolationType.Potential;
    }
    return ViolationType.NoViolation;
};
export const principlesIndexes = {
    environmentEndIndex: 9,
    humanRightsEndIndex: 2,
    labourEndIndex: 6
};
export const getPrincipleNumber = (principle) => Number(principle.substring("PRINCIPLE".length));
const principleDescriptions = [
    principlesTable.descriptions.principle1,
    principlesTable.descriptions.principle2,
    principlesTable.descriptions.principle3,
    principlesTable.descriptions.principle4,
    principlesTable.descriptions.principle5,
    principlesTable.descriptions.principle6,
    principlesTable.descriptions.principle7,
    principlesTable.descriptions.principle8,
    principlesTable.descriptions.principle9,
    principlesTable.descriptions.principle10
];
export const getPrincipleDescription = (value) => {
    if (value) {
        const pn = getPrincipleNumber(value);
        if (isFinite(pn) && pn >= 1 && pn <= principleDescriptions.length) {
            return principleDescriptions[pn - 1];
        }
    }
    return value;
};
